import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';
import { AppUser }              from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findAppUserRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findAppUserSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{
  appUser: AppUser
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.appUser.id]: payload.appUser };
};

export const findAppUserFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
